/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Select_All_EventsInputs */



/**
* | output |
* | --- |
* | "Select all events in event group" |
*
* @param {Shortcut_Keys_Desc_Select_All_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_select_all_events = /** @type {((inputs?: Shortcut_Keys_Desc_Select_All_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Select_All_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner tous les evenements du groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie alle Ereignisse in der Ereignisgruppe aus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona tutti gli eventi nel gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите все события в группе событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar todos los eventos en el grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择事件组中的所有事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループ内のすべてのイベントを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह में सभी इवेंट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione todos os eventos no grupo de eventos")
	return /** @type {LocalizedString} */ ("Select all events in event group")
});